import { PaginationRequest } from '../config/common';

export class PaginationVehicleTypeRequest extends PaginationRequest {
    name?: string = '';
  customerFacing?: boolean;
  isDefault: boolean;
}

export interface CreateVehicleTypeRequest {
    name?: string;
  customerFacing?: boolean;
  isDefault: boolean;
}
